import { render, staticRenderFns } from "./homeUat.vue?vue&type=template&id=2da2505e&"
import script from "./homeUat.vue?vue&type=script&lang=js&"
export * from "./homeUat.vue?vue&type=script&lang=js&"
import style0 from "./homeUat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports